"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var $dyn;
(function ($dyn) {
    $dyn.GroupInfoManager = {};
    var reactGrid;
    (function (reactGrid) {
        reactGrid.MASTERTRACKINGID = "MasterTrackingId";
        reactGrid.ISMARKED_NAME = "_RESERVED_IsMarked";
        reactGrid.ISSELECTED_NAME = "_RESERVED_IsSelected";
        reactGrid.ISACTIVE_NAME = "_RESERVED_IsActive";
        reactGrid.PARENT_GROUP_KEY = "_RESERVED_ParentGroup";
        reactGrid.ISACTIONABLE_NAME = "_RESERVED_IsActionable";
        reactGrid.GROUP_HEADER_PREFIX = "_GroupHeader";
        var GROUP_BY_KEY = "_RESERVED_GroupBy";
        var SHOW_GROUP_CALCULATE_LINK = "_RESERVED_GroupCalculateLink";
        var IS_COLLAPSED_KEY = "_RESERVED_GroupHeaderIsCollapsed";
        var GROUP_LEVEL_KEY = "_RESERVED_GroupLevel";
        var GROUPING_FEATURE_NAME = "CLIGridGroupingFeature";
        var GRID_PROPERTIES_TO_OBSERVE = {
            ShowGroupHeaderLabel: true,
        };
        reactGrid.MAX_LEVEL_GROUPING = 5;
        var GroupingManager = /** @class */ (function () {
            function GroupingManager(context) {
                var _this = this;
                this.context = context;
                this.getComboBoxValue = function (idx, key, dsName, columnInfo) {
                    var value = _this.context.getCollectionData(idx, key, dsName);
                    var items = $dyn.util.convertItems($dyn.peek(columnInfo.Items));
                    var selectedItem = ControlLibrary.getSelectedItemByValue(value, items);
                    return selectedItem && selectedItem.text;
                };
                this.updatingGroupHeaders = false;
                this.gridPropertyObservers = [];
                this.rowIndexToTrackingId = [];
                this.activeGroupTrackingId = "";
                this.columnGrouping = [];
                this.collectionName = "";
                if (context) {
                    if ($dyn.isServerBoundDataSource(context.DataSource)) {
                        this.collectionName = context.DataSource.__dataSourceName;
                    }
                    if (context.Root && context.Root.Id) {
                        this.rootId = context.Root.Id;
                    }
                    if (GroupingManager.flightEnabled()) {
                        this.gridPropertyObservers.push($dyn.observe(context.ColumnGrouping, function (newGrouping) {
                            if (!newGrouping) {
                                _this.columnGrouping = [];
                            }
                            else {
                                try {
                                    _this.columnGrouping = JSON.parse(newGrouping).ColumnGroupings;
                                    if (_this.columnGrouping.length > reactGrid.MAX_LEVEL_GROUPING) {
                                        _this.columnGrouping.splice(reactGrid.MAX_LEVEL_GROUPING);
                                    }
                                }
                                catch (_a) {
                                    _this.columnGrouping = [];
                                }
                            }
                            if (!_this.context.firstRender) {
                                _this.updateGroupHeadersAndRerender();
                            }
                        }));
                        this.gridPropertyObservers.push($dyn.bulkObserve(context, function () { _this.updateGroupHeadersAndRerender(); }, context.Updating, this, undefined, GRID_PROPERTIES_TO_OBSERVE, true));
                    }
                }
            }
            // Need static methods for GroupingManger calls in Model.ts
            GroupingManager.flightEnabled = function () {
                return $dyn.util.isFlightEnabled(GROUPING_FEATURE_NAME);
            };
            /**
             * Get group off of $dyn.GroupInfoManager global cache
             */
            GroupingManager.getGroup = function (rootId, collectionName, trackingId) {
                if ($dyn.GroupInfoManager[rootId] && $dyn.GroupInfoManager[rootId][collectionName]) {
                    return $dyn.GroupInfoManager[rootId][collectionName][trackingId];
                }
            };
            /**
             * Adjust marked count for group and its ancestors
             */
            GroupingManager.adjustMarkedCountForHierarchy = function (rootId, collectionName, trackingId, adjustment) {
                var groupInfo = GroupingManager.getGroup(rootId, collectionName, trackingId);
                var groupInfoInHierarchy = groupInfo;
                while (groupInfoInHierarchy) {
                    groupInfoInHierarchy.adjustMarkedCount(adjustment);
                    if (groupInfoInHierarchy.parentGroupTrackingId) {
                        groupInfoInHierarchy = GroupingManager.getGroup(rootId, collectionName, groupInfoInHierarchy.parentGroupTrackingId);
                    }
                    else {
                        groupInfoInHierarchy = undefined;
                    }
                }
            };
            /**
             * Add field total for group and its ancestors
             * @param rootId The id of the form
             * @param collectionName The name of the master data source of the grid the grouping is applied
             * @param trackingId The group gracking id
             * @param dataSourceName The data source of the field we are totalling
             * @param fieldName The name of the field we are totalling
             * @param value The value to be added to the existing total
             */
            GroupingManager.addFieldTotalForHierarchy = function (rootId, collectionName, trackingId, dataSourceName, fieldName, value) {
                var groupInfo = GroupingManager.getGroup(rootId, collectionName, trackingId);
                var groupInfoInHierarchy = groupInfo;
                while (groupInfoInHierarchy) {
                    groupInfoInHierarchy.addFieldTotal(value, fieldName, dataSourceName);
                    if (groupInfoInHierarchy.parentGroupTrackingId) {
                        groupInfoInHierarchy = GroupingManager.getGroup(rootId, collectionName, groupInfoInHierarchy.parentGroupTrackingId);
                    }
                    else {
                        groupInfoInHierarchy = undefined;
                    }
                }
            };
            /**
             * Force groupingManager for a group with this rootId and collectionName to re-calculate and rerender
             */
            GroupingManager.updateHeadersAndRerender = function (rootId, collectionName) {
                var groupInfo = GroupingManager.getAnyGroup(rootId, collectionName);
                if (groupInfo && groupInfo.groupingManager) {
                    groupInfo.groupingManager.updateGroupHeadersAndRerender();
                }
            };
            /**
             * Add new records and potentially new groups
             * @param rootId The id of the form
             * @param collectionName The collection name of the datasource the grid is bound to
             * @param collectionData The added rows to that model collection
             * @param lastGroupTrackingId Parent group tracking id of the last row in the collection before the passed in collectionData was added
             */
            GroupingManager.addNewRowsToGroupingManger = function (rootId, collectionName, collectionData, lastGroupTrackingId) {
                var e_1, _a;
                var groupInfo = GroupingManager.getAnyGroup(rootId, collectionName);
                if (groupInfo && groupInfo.groupingManager && $dyn.length(groupInfo.groupingManager.columnGrouping) > 0) {
                    if (lastGroupTrackingId) {
                        // If there is a last group tracking id that means that we are adding to existing data
                        var groupingData = groupInfo.groupingManager.getColumnGroupingData();
                        if ($dyn.length(groupingData) > 0) {
                            // calculate a map of groups based on only the added data, imclude offset for row index since we are adding to existing rows
                            var groupingOutput = groupInfo.groupingManager.calculateGroups(groupingData, collectionData, groupInfo.groupingManager.rowIndexToTrackingId.length);
                            var newGroups = groupingOutput.groups;
                            var newRowIndexToTrackingId = groupingOutput.trackingIds;
                            // If creating a new root level group, we need to update the nextgrouptrackingid of the current last root group
                            // and the previousgrouptrackingid for the first root group in the new groups we are adding
                            var groupInfoInHierarchy = GroupingManager.getGroup(rootId, collectionName, lastGroupTrackingId);
                            while (groupInfoInHierarchy.parentGroupTrackingId) {
                                groupInfoInHierarchy = GroupingManager.getGroup(rootId, collectionName, groupInfoInHierarchy.parentGroupTrackingId);
                            }
                            var lastGroupRootGroupTrackingId = groupInfoInHierarchy.trackingId;
                            var rootLevelIsSame = (newRowIndexToTrackingId[0] === lastGroupRootGroupTrackingId);
                            if (!rootLevelIsSame) {
                                var lastRootGroupInfo = GroupingManager.getGroup(rootId, collectionName, lastGroupRootGroupTrackingId);
                                lastRootGroupInfo.nextGroupTrackingId = newRowIndexToTrackingId[0];
                                var firstRootNewGroupInfo = newGroups[newRowIndexToTrackingId[0]];
                                firstRootNewGroupInfo.previousGroupTrackingId = lastGroupRootGroupTrackingId;
                            }
                            var _loop_1 = function (trackingIdToAdd) {
                                if (trackingIdToAdd.startsWith(reactGrid.GROUP_HEADER_PREFIX)) {
                                    var newGroup_1 = newGroups[trackingIdToAdd];
                                    var existingGroup_1 = GroupingManager.getGroup(rootId, collectionName, trackingIdToAdd);
                                    if (existingGroup_1) {
                                        existingGroup_1.endIndex = newGroup_1.endIndex;
                                        existingGroup_1.nextGroupTrackingId = newGroup_1.nextGroupTrackingId;
                                        if (newGroup_1.hasSubGroups()) {
                                            var subGroupStartIndex = 0;
                                            if (existingGroup_1.getLastSubGroupTrackingId() === newGroup_1.getFirstSubGroupTrackingId()) {
                                                // May have overlap so dont add that subgroup twice
                                                subGroupStartIndex++;
                                            }
                                            var newGroupSubGroups = newGroup_1.getSubGroups();
                                            for (var subGroupIndex = subGroupStartIndex; subGroupIndex < newGroupSubGroups.length; subGroupIndex++) {
                                                existingGroup_1.addSubGroup(newGroupSubGroups[subGroupIndex]);
                                            }
                                        }
                                        var columnsWithTotals = existingGroup_1.groupingManager.context.getColumnsWithTotals();
                                        columnsWithTotals.forEach(function (columnToTotal) {
                                            var totalValue = newGroup_1.getValue(columnToTotal.FieldName, columnToTotal.DataSourceName);
                                            if (totalValue) {
                                                existingGroup_1.addFieldTotal(totalValue, columnToTotal.FieldName, columnToTotal.DataSourceName);
                                            }
                                        });
                                    }
                                    else {
                                        groupInfo.groupingManager.rowIndexToTrackingId.push(trackingIdToAdd);
                                        GroupingManager.addGroup(rootId, collectionName, newGroup_1);
                                    }
                                }
                                else {
                                    groupInfo.groupingManager.rowIndexToTrackingId.push(trackingIdToAdd);
                                }
                            };
                            try {
                                for (var newRowIndexToTrackingId_1 = __values(newRowIndexToTrackingId), newRowIndexToTrackingId_1_1 = newRowIndexToTrackingId_1.next(); !newRowIndexToTrackingId_1_1.done; newRowIndexToTrackingId_1_1 = newRowIndexToTrackingId_1.next()) {
                                    var trackingIdToAdd = newRowIndexToTrackingId_1_1.value;
                                    _loop_1(trackingIdToAdd);
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (newRowIndexToTrackingId_1_1 && !newRowIndexToTrackingId_1_1.done && (_a = newRowIndexToTrackingId_1.return)) _a.call(newRowIndexToTrackingId_1);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                        }
                    }
                    else {
                        // if there is no existing data, then just go through the normal path
                        groupInfo.groupingManager.updateGroupHeadersAndRerender();
                    }
                }
            };
            /**
             * Remove a row from a group by decrementing the endIndex, recursively removes groups if now empty
             * @param rootId The form id
             * @param collectionName The name of the collection bound to the grid
             * @param trackingId The group's tracking id we are removing a row from
             * @returns Object describing the row index of first group header removed and how many group headers removed
             */
            GroupingManager.removeFromGroup = function (rootId, collectionName, trackingId) {
                var firstIndex = -1;
                var deleteCount = 0;
                var groupInfo = GroupingManager.getGroup(rootId, collectionName, trackingId);
                var groupInfoInHierarchy = groupInfo;
                while (groupInfoInHierarchy) {
                    groupInfoInHierarchy.endIndex--;
                    if (groupInfoInHierarchy.numberOfRows === 0) {
                        GroupingManager.deleteGroup(rootId, collectionName, trackingId);
                        if (groupInfoInHierarchy.rowIndex !== -1) {
                            if (firstIndex === -1 || groupInfoInHierarchy.rowIndex < firstIndex) {
                                firstIndex = groupInfoInHierarchy.rowIndex;
                            }
                            deleteCount++;
                        }
                    }
                    if (groupInfoInHierarchy.parentGroupTrackingId) {
                        groupInfoInHierarchy = GroupingManager.getGroup(rootId, collectionName, groupInfoInHierarchy.parentGroupTrackingId);
                    }
                    else {
                        groupInfoInHierarchy = undefined;
                    }
                }
                return { firstIndex: firstIndex, deleteCount: deleteCount };
            };
            /**
             * Remove rows from rowIndexToTrackingId for the grouping manger for a given form and collection name
             */
            GroupingManager.removeRowsFromGroupingManager = function (rootId, collectionName, startIndex, deleteCount) {
                var groupInfo = GroupingManager.getAnyGroup(rootId, collectionName);
                if (groupInfo && groupInfo.groupingManager) {
                    groupInfo.groupingManager.removeFromRowIndices(startIndex, deleteCount);
                }
            };
            /**
             * Get any group since they all have a reference to the grouping manager
             */
            GroupingManager.getAnyGroup = function (rootId, collectionName) {
                var groupInfo;
                if ($dyn.GroupInfoManager[rootId] && $dyn.GroupInfoManager[rootId][collectionName]) {
                    for (var trackingId in $dyn.GroupInfoManager[rootId][collectionName]) {
                        if ($dyn.GroupInfoManager[rootId][collectionName][trackingId]) {
                            groupInfo = $dyn.GroupInfoManager[rootId][collectionName][trackingId];
                            break;
                        }
                    }
                }
                return groupInfo;
            };
            /**
             * Remove group from cache
             */
            GroupingManager.deleteGroup = function (rootId, collectionName, trackingId) {
                if ($dyn.GroupInfoManager[rootId] && $dyn.GroupInfoManager[rootId][collectionName]) {
                    delete $dyn.GroupInfoManager[rootId][collectionName][trackingId];
                }
            };
            /**
             * Add group to cache
             */
            GroupingManager.addGroup = function (rootId, collectionName, groupInfo) {
                if (!rootId || !collectionName || !groupInfo) {
                    return;
                }
                if (!$dyn.GroupInfoManager[rootId]) {
                    $dyn.GroupInfoManager[rootId] = {};
                }
                if (!$dyn.GroupInfoManager[rootId][collectionName]) {
                    $dyn.GroupInfoManager[rootId][collectionName] = {};
                }
                $dyn.GroupInfoManager[rootId][collectionName][groupInfo.trackingId] = groupInfo;
            };
            GroupingManager.prototype.dispose = function () {
                var e_2, _a;
                if (this.gridPropertyObservers) {
                    try {
                        for (var _b = __values(this.gridPropertyObservers), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var observer = _c.value;
                            observer.dispose();
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    this.gridPropertyObservers = [];
                }
                this.rowIndexToTrackingId = [];
                if (this.fallbackGroupInfoCache) {
                    delete this.fallbackGroupInfoCache;
                }
            };
            GroupingManager.prototype.addNewRow = function (newRow, lastGroupTrackingId) {
                GroupingManager.addNewRowsToGroupingManger(this.rootId, this.collectionName, [newRow], lastGroupTrackingId);
            };
            /**
             * Supply arguments for splice on rowIndexToTrackingId, then update row indexes of remaining items
             */
            GroupingManager.prototype.removeFromRowIndices = function (startIndex, deleteCount) {
                this.rowIndexToTrackingId.splice(startIndex, deleteCount);
                // Update row indices on groups and rows
                for (var i = startIndex; i < this.rowIndexToTrackingId.length; i++) {
                    var trackingId = this.rowIndexToTrackingId[i];
                    if (trackingId.startsWith(reactGrid.GROUP_HEADER_PREFIX)) {
                        this.getGroup(trackingId).rowIndex = i;
                    }
                    else {
                        var collectionData = $dyn.value(this.context.DataSource);
                        var collectionIndex = this.context.getCollectionIndexFromTrackingId(trackingId);
                        var item = collectionData[collectionIndex];
                        item.rowIndex = i;
                    }
                }
            };
            /**
             * Gets the offset from the data source length to the number of rows in the grid
             */
            GroupingManager.prototype.collectionLengthOffset = function () {
                if (!this.hasGrouping() || this.rowIndexToTrackingId.length <= 0) {
                    return 0;
                }
                return this.rowIndexToTrackingId.length - $dyn.length(this.context.DataSource);
            };
            /**
             * Persists the column grouping through personalization
             * @param columns The columns to be grouped or null to clear out current grouping
             */
            GroupingManager.prototype.group = function (columnGroupings, useAsync) {
                var _this = this;
                if (useAsync === void 0) { useAsync = false; }
                var newGrouping = columnGroupings ? JSON.stringify(columnGroupings) : "";
                $dyn.setValue(this.context, "ColumnGrouping", newGrouping);
                if (useAsync) {
                    $dyn.async(function () {
                        $dyn.callFunction(_this.context.UpdateColumnGrouping, _this.context, newGrouping);
                    });
                }
                else {
                    $dyn.callFunction(this.context.UpdateColumnGrouping, this.context, newGrouping);
                }
            };
            GroupingManager.prototype.isGroupHeader = function (rowIndex) {
                if (rowIndex === -1 || !this.hasGrouping() || this.rowIndexToTrackingId.length <= 0 || rowIndex > this.rowIndexToTrackingId.length) {
                    return false;
                }
                var trackingId = this.rowIndexToTrackingId[rowIndex];
                return trackingId.startsWith(reactGrid.GROUP_HEADER_PREFIX);
            };
            /**
             * Check if the group with the corresponding groupTrackingId is the first group
             * @param groupTrackingId the groupTrackingId to check
             */
            GroupingManager.prototype.isFirstGroup = function (groupTrackingId) {
                // recursively check to see if first group at every level
                var groupInfo = this.getGroup(groupTrackingId);
                if (!groupInfo.previousGroupTrackingId) {
                    if (groupInfo.parentGroupTrackingId) {
                        return this.isFirstGroup(groupInfo.parentGroupTrackingId);
                    }
                    return true;
                }
                return false;
            };
            /**
             * Check if the group with the corresponding groupTrackingId is the last group
             * @param groupTrackingId the groupTrackingId to check
             */
            GroupingManager.prototype.isLastGroup = function (groupTrackingId) {
                // rescursively check to see if last group at every level
                var groupInfo = this.getGroup(groupTrackingId);
                if (!groupInfo.nextGroupTrackingId) {
                    if (groupInfo.parentGroupTrackingId) {
                        return this.isLastGroup(groupInfo.parentGroupTrackingId);
                    }
                    return true;
                }
                return false;
            };
            /**
             * Get the value off of the group info
             */
            GroupingManager.prototype.getGroupHeaderData = function (rowIndex, columnKey, dataSourceName) {
                var groupTrackingId = this.rowIndexToTrackingId[rowIndex];
                var groupInfo = this.getGroup(groupTrackingId);
                return groupInfo.getValue(columnKey, dataSourceName);
            };
            /**
             * Get the start collection index of the group
             * @param trackingId Group tracking id
             */
            GroupingManager.prototype.getGroupStartIndex = function (trackingId) {
                var groupInfo = this.getGroup(trackingId);
                return groupInfo.startIndex;
            };
            /**
             * Get the end collection index of the group
             * @param trackingId Group tracking id
             */
            GroupingManager.prototype.getGroupEndIndex = function (trackingId) {
                var groupInfo = this.getGroup(trackingId);
                return groupInfo.endIndex;
            };
            GroupingManager.prototype.getGroupIsCollapsed = function (trackingId) {
                var groupInfo = this.getGroup(trackingId);
                return groupInfo.isCollapsed;
            };
            GroupingManager.prototype.clearActiveGroup = function () {
                // Clear out any active group
                if (this.activeGroupTrackingId.length) {
                    var groupInfo = this.getGroup(this.activeGroupTrackingId);
                    if (groupInfo) {
                        groupInfo.isActiveDataRow = false;
                    }
                }
            };
            /** Get total number of groups created */
            GroupingManager.prototype.getNumberOfGroups = function () {
                if (this.rootId && this.collectionName) {
                    if ($dyn.GroupInfoManager[this.rootId] && $dyn.GroupInfoManager[this.rootId][this.collectionName]) {
                        return Object.keys($dyn.GroupInfoManager[this.rootId][this.collectionName]).length;
                    }
                }
                else if (this.fallbackGroupInfoCache) {
                    return Object.keys(this.fallbackGroupInfoCache).length;
                }
                return 0;
            };
            /**
             * Convert from index in grid to index in collection
             */
            GroupingManager.prototype.rowIndexToCollectionIndex = function (rowIndex) {
                if (!this.hasGrouping() || this.rowIndexToTrackingId.length <= 0) {
                    return rowIndex;
                }
                // Group headers arent in the collection so return -1 in that case
                if (rowIndex !== -1 && this.rowIndexToTrackingId[rowIndex] !== undefined && !this.isGroupHeader(rowIndex)) {
                    return this.context.getCollectionIndexFromTrackingId(this.rowIndexToTrackingId[rowIndex]);
                }
                return -1;
            };
            /**
             * Convert from index in collection to index in grid
             */
            GroupingManager.prototype.collectionIndexToRowIndex = function (collectionIndex) {
                if (!this.hasGrouping() || !this.groupingApplied()) {
                    return collectionIndex;
                }
                if (collectionIndex !== -1) {
                    var collectionData = $dyn.peek(this.context.DataSource);
                    var model = collectionData[collectionIndex];
                    if (model) {
                        return model.rowIndex;
                    }
                }
                return -1;
            };
            GroupingManager.prototype.getTrackingIdFromRowIndex = function (rowIndex) {
                if (this.rowIndexToTrackingId.length > 0) {
                    return this.rowIndexToTrackingId[rowIndex];
                }
                return this.context.getTrackingIdFromCollectionIndex(this.rowIndexToCollectionIndex(rowIndex));
            };
            GroupingManager.prototype.getRowIndexFromTrackingId = function (trackingId) {
                if (trackingId.startsWith(reactGrid.GROUP_HEADER_PREFIX)) {
                    var groupInfo = this.getGroup(trackingId);
                    if (groupInfo) {
                        return groupInfo.rowIndex;
                    }
                    // Couldn't find the group info for some reason, so return -1
                    return -1;
                }
                var collectionIndex = this.context.getCollectionIndexFromTrackingId(trackingId);
                return this.collectionIndexToRowIndex(collectionIndex);
            };
            /**
             * Update group headers, reset grouping grid options, and call render
             */
            GroupingManager.prototype.updateGroupHeadersAndRerender = function () {
                this.updateGroupHeaders();
                if (this.context.firstRender) {
                    this.context.firstRender = false;
                    this.context.renderReactListSync();
                }
                else {
                    if (GroupingManager.flightEnabled()) {
                        this.context.resetGroupingGridOptions();
                    }
                    this.context.markedSelectedVersion++;
                    this.context.dataVersion++;
                    this.context.renderReactListAsync();
                }
            };
            GroupingManager.prototype.toggleGroupExpandCollapse = function (rowIndex) {
                var _a, e_3, _b;
                var groupTrackingId = this.rowIndexToTrackingId[rowIndex];
                var groupInfo = this.getGroup(groupTrackingId);
                if (groupInfo.isCollapsed) {
                    // Expanding the group
                    // Need to update this to expanded before get tracking id's call
                    groupInfo.isCollapsed = false;
                    var trackingIdsToAdd = this.getVisibleTrackingIdsForGroup(groupTrackingId);
                    if (groupInfo.isActiveDataRow) {
                        groupInfo.isActiveDataRow = false;
                        this.activeGroupTrackingId = "";
                        this.resetIsActiveRowOnSubGroup(groupInfo, false);
                    }
                    // insert new trackingIds into rowIndexToTrackingId array
                    (_a = this.rowIndexToTrackingId).splice.apply(_a, __spread([rowIndex + 1, 0], trackingIdsToAdd));
                }
                else {
                    // Collapsing the group
                    var collectionRowIndex = this.context.getCollectionIndexFromActiveRowTrackingId();
                    // If active data row is inside group we are collapsing, set isActiveDataRow to true
                    if (collectionRowIndex >= groupInfo.startIndex && collectionRowIndex <= groupInfo.endIndex) {
                        groupInfo.isActiveDataRow = true;
                        this.activeGroupTrackingId = groupInfo.trackingId;
                        this.resetIsActiveRowOnSubGroup(groupInfo, true);
                    }
                    // reset rowIndex for hidden rows to -1
                    var trackingIdsToRemove = this.getVisibleTrackingIdsForGroup(groupTrackingId);
                    try {
                        for (var trackingIdsToRemove_1 = __values(trackingIdsToRemove), trackingIdsToRemove_1_1 = trackingIdsToRemove_1.next(); !trackingIdsToRemove_1_1.done; trackingIdsToRemove_1_1 = trackingIdsToRemove_1.next()) {
                            var trackingIdToRemove = trackingIdsToRemove_1_1.value;
                            if (trackingIdToRemove.startsWith(reactGrid.GROUP_HEADER_PREFIX)) {
                                this.getGroup(trackingIdToRemove).rowIndex = -1;
                            }
                            else {
                                var collectionData = $dyn.value(this.context.DataSource);
                                var collectionIndex = this.context.getCollectionIndexFromTrackingId(trackingIdToRemove);
                                var item = collectionData[collectionIndex];
                                item.rowIndex = -1;
                            }
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (trackingIdsToRemove_1_1 && !trackingIdsToRemove_1_1.done && (_b = trackingIdsToRemove_1.return)) _b.call(trackingIdsToRemove_1);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                    // remove tracking ids from rowIndexToTrackingId array
                    this.rowIndexToTrackingId.splice(rowIndex + 1, trackingIdsToRemove.length);
                    groupInfo.isCollapsed = true;
                }
                // update rowIndex on each model and group
                for (var i = rowIndex + 1; i < this.rowIndexToTrackingId.length; i++) {
                    var trackingId = this.rowIndexToTrackingId[i];
                    if (trackingId.startsWith(reactGrid.GROUP_HEADER_PREFIX)) {
                        this.getGroup(trackingId).rowIndex = i;
                    }
                    else {
                        var collectionData = $dyn.value(this.context.DataSource);
                        var collectionIndex = this.context.getCollectionIndexFromTrackingId(trackingId);
                        var item = collectionData[collectionIndex];
                        item.rowIndex = i;
                    }
                }
            };
            GroupingManager.prototype.adjustGroupMarkCount = function (trackingId, adjustment) {
                var groupInfo = this.getGroup(trackingId);
                groupInfo.adjustMarkedCount(adjustment);
            };
            GroupingManager.prototype.hasGrouping = function () {
                return GroupingManager.flightEnabled() && $dyn.length(this.columnGrouping) > 0;
            };
            /**
             * Method to be run when the model collection gets a cache clear
             * @returns True if grouping manager will cause rerender, otherwise false
             */
            GroupingManager.prototype.onCacheClear = function () {
                var e_4, _a;
                var newGrouping = [];
                var currentGroupingDepth = $dyn.length(this.columnGrouping);
                if (currentGroupingDepth > 0) {
                    try {
                        // loop through columngrouping to get columnInfo
                        // if columnInfo has a sort direction of none, then remove it from columngrouping
                        for (var _b = __values(this.columnGrouping), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var columnGroupingData = _c.value;
                            var columnToGroupBy = columnGroupingData.ControlName;
                            var columnInfo = this.context.getColumnInfo(columnToGroupBy);
                            if (columnInfo) {
                                var colSortDir = $dyn.value(columnInfo.SortDirection);
                                if (colSortDir === 0 || colSortDir === 1) {
                                    newGrouping.push(columnGroupingData);
                                }
                            }
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                    if (newGrouping.length !== currentGroupingDepth) {
                        // Need to call group so that ColumnGrouping property is updated
                        this.group(newGrouping.length > 0 ? { ColumnGroupings: newGrouping } : null);
                    }
                    else {
                        this.updateGroupHeadersAndRerender();
                    }
                    return true;
                }
                return false;
            };
            GroupingManager.prototype.resetIsActiveRowOnSubGroup = function (parentGroupInfo, isCollapsing) {
                var e_5, _a;
                var collectionRowIndex = this.context.getCollectionIndexFromActiveRowTrackingId();
                if (parentGroupInfo && parentGroupInfo.getSubGroups) {
                    var subGroupTrackingIds = parentGroupInfo.getSubGroups();
                    if (subGroupTrackingIds) {
                        try {
                            for (var subGroupTrackingIds_1 = __values(subGroupTrackingIds), subGroupTrackingIds_1_1 = subGroupTrackingIds_1.next(); !subGroupTrackingIds_1_1.done; subGroupTrackingIds_1_1 = subGroupTrackingIds_1.next()) {
                                var trackingId = subGroupTrackingIds_1_1.value;
                                var groupInfo = this.getGroup(trackingId);
                                this.resetIsActiveRowOnSubGroup(groupInfo, isCollapsing);
                                if (groupInfo) {
                                    if (isCollapsing && groupInfo.isActiveDataRow) {
                                        groupInfo.isActiveDataRow = false;
                                    }
                                    else if (!isCollapsing &&
                                        groupInfo.isCollapsed &&
                                        collectionRowIndex >= groupInfo.startIndex &&
                                        collectionRowIndex <= groupInfo.endIndex) {
                                        groupInfo.isActiveDataRow = true;
                                        this.activeGroupTrackingId = groupInfo.trackingId;
                                    }
                                }
                            }
                        }
                        catch (e_5_1) { e_5 = { error: e_5_1 }; }
                        finally {
                            try {
                                if (subGroupTrackingIds_1_1 && !subGroupTrackingIds_1_1.done && (_a = subGroupTrackingIds_1.return)) _a.call(subGroupTrackingIds_1);
                            }
                            finally { if (e_5) throw e_5.error; }
                        }
                    }
                }
            };
            GroupingManager.prototype.groupingApplied = function () {
                return this.getNumberOfGroups() > 0;
            };
            /**
             * Get grouping data from the columns provided in columnGrouping
             */
            GroupingManager.prototype.getColumnGroupingData = function () {
                var e_6, _a;
                var groupingData = [];
                try {
                    for (var _b = __values(this.columnGrouping), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var columnGroupingData = _c.value;
                        var columnToGroupBy = columnGroupingData.ControlName;
                        var columnInfo = this.context.getColumnInfo(columnToGroupBy);
                        if (columnInfo) {
                            var filteringFields = this.context.getFilteringFieldsForColumn(columnInfo);
                            // filterFields is only more than one entry for multi-part reference groups
                            var firstFilterField = filteringFields[0];
                            groupingData.push({
                                columnInfo: columnInfo,
                                dataSourceName: firstFilterField.FormDataSourceName,
                                fieldName: firstFilterField.FieldName,
                                label: firstFilterField.Label
                            });
                        }
                    }
                }
                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_6) throw e_6.error; }
                }
                return groupingData;
            };
            /**
             * Calls calculate groups or clears existing grouping
             */
            GroupingManager.prototype.updateGroupHeaders = function () {
                if (this.updatingGroupHeaders || !GroupingManager.flightEnabled()) {
                    return;
                }
                this.updatingGroupHeaders = true;
                this.rowIndexToTrackingId = [];
                var collectionData = $dyn.peek(this.context.DataSource);
                if ($dyn.length(this.columnGrouping) > 0) {
                    var groupingData = this.getColumnGroupingData();
                    if ($dyn.length(groupingData) > 0) {
                        var groupingOutput = this.calculateGroups(groupingData, collectionData);
                        var newGroups = groupingOutput.groups;
                        this.rowIndexToTrackingId = groupingOutput.trackingIds;
                        if (this.rootId && this.collectionName) {
                            if (!$dyn.GroupInfoManager[this.rootId]) {
                                $dyn.GroupInfoManager[this.rootId] = {};
                            }
                            if (!$dyn.GroupInfoManager[this.rootId][this.collectionName]) {
                                $dyn.GroupInfoManager[this.rootId][this.collectionName] = {};
                            }
                            $dyn.GroupInfoManager[this.rootId][this.collectionName] = newGroups;
                        }
                        else {
                            this.fallbackGroupInfoCache = newGroups;
                        }
                    }
                }
                else {
                    // clear grouping
                    var needToClearModelValues = false;
                    if (this.groupingApplied()) {
                        needToClearModelValues = true;
                        if (this.rootId && this.collectionName) {
                            delete $dyn.GroupInfoManager[this.rootId][this.collectionName];
                        }
                        else {
                            delete this.fallbackGroupInfoCache;
                        }
                    }
                    if (needToClearModelValues) {
                        // if active row was a group header, reset the active row to be the SelectedTrackingId
                        var currentTrackingId = $dyn.value(this.context.InternalSelectedRowTrackingId);
                        if (currentTrackingId && currentTrackingId.startsWith(reactGrid.GROUP_HEADER_PREFIX)) {
                            this.context.resetInternalSelectedTrackingId();
                        }
                        collectionData.forEach(function (item) {
                            if ($dyn.serverForm && $dyn.serverForm.isModel(item)) {
                                item.removeProperty(reactGrid.PARENT_GROUP_KEY);
                            }
                            else {
                                delete item[reactGrid.PARENT_GROUP_KEY];
                            }
                        });
                    }
                }
                this.updatingGroupHeaders = false;
            };
            /**
             * Recursively get child tracking ids (including subgroups) for a group
             */
            GroupingManager.prototype.getVisibleTrackingIdsForGroup = function (groupTrackingId) {
                var e_7, _a;
                var trackingIds = [];
                var groupInfo = this.getGroup(groupTrackingId);
                if (!groupInfo.isCollapsed) {
                    if (groupInfo.hasSubGroups()) {
                        try {
                            for (var _b = __values(groupInfo.getSubGroups()), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var subGroupId = _c.value;
                                trackingIds.push(subGroupId);
                                Array.prototype.push.apply(trackingIds, this.getVisibleTrackingIdsForGroup(subGroupId));
                            }
                        }
                        catch (e_7_1) { e_7 = { error: e_7_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_7) throw e_7.error; }
                        }
                    }
                    else {
                        for (var index = groupInfo.startIndex; index <= groupInfo.endIndex; index++) {
                            trackingIds.push(this.context.getTrackingIdFromCollectionIndex(index));
                        }
                    }
                }
                return trackingIds;
            };
            /**
             * Generate tracking id given columns being grouped on and their values
             */
            GroupingManager.prototype.getGroupTrackingId = function (groupingData, values) {
                var groupId = reactGrid.GROUP_HEADER_PREFIX;
                // Note: values maybe shorter than groupData but will never be longer
                for (var level = 0; level < values.length; level++) {
                    groupId += "_" + groupingData[level].columnInfo._name + "_" + values[level];
                }
                return groupId;
            };
            /**
             * Create groups based off provided collection data and groups and collection data to rowIndexToTrackingId array
             * @param groupingInfo The array of grouping data
             * @param collectionData The collection data of the grid
             * @param rowIndexOffset The offset to add to the row indices calculated
             */
            GroupingManager.prototype.calculateGroups = function (groupingData, collectionData, rowIndexOffset) {
                var e_8, _a;
                var _this = this;
                if (rowIndexOffset === void 0) { rowIndexOffset = 0; }
                var columnsWithTotals = this.context.getColumnsWithTotals();
                var lastGroupingLevel = groupingData.length - 1;
                // Create an array of value getters with the index corresponding to the group level
                var valueGetters = [];
                var _loop_2 = function (groupData) {
                    var columnInfo = groupData.columnInfo;
                    var getValue = void 0;
                    if (columnInfo.TypeName === "ComboBox") {
                        getValue = this_1.getComboBoxValue;
                    }
                    else if (columnInfo.TypeName === "Date" || columnInfo.TypeName === "DateTime") {
                        getValue = function (idx, key, dsName) {
                            var value = _this.context.getCollectionData(idx, key, dsName);
                            return $dyn.controls.DateTime.getFormattedValue(value, columnInfo);
                        };
                    }
                    else {
                        // TODO: need to format number and time values as well
                        getValue = function (idx, key, dsName, _) { return _this.context.getCollectionData(idx, key, dsName); };
                    }
                    valueGetters.push(getValue);
                };
                var this_1 = this;
                try {
                    for (var groupingData_1 = __values(groupingData), groupingData_1_1 = groupingData_1.next(); !groupingData_1_1.done; groupingData_1_1 = groupingData_1.next()) {
                        var groupData = groupingData_1_1.value;
                        _loop_2(groupData);
                    }
                }
                catch (e_8_1) { e_8 = { error: e_8_1 }; }
                finally {
                    try {
                        if (groupingData_1_1 && !groupingData_1_1.done && (_a = groupingData_1.return)) _a.call(groupingData_1);
                    }
                    finally { if (e_8) throw e_8.error; }
                }
                var newGroups = {};
                var newRowIndexToTrackingId = [];
                var groupByKeys = new Map();
                var lastItemValues = [];
                // collection data has be sorted at this point
                collectionData.forEach(function (item, index) {
                    var collectionIndex = $dyn.serverForm.isModel(item) ? item.collectionIndex : index;
                    // create groups with necessary data:
                    //  - start and end collection index
                    //  - row index
                    //  - parent group id
                    //  - string array of subgroup ids
                    //  - next/previous group id
                    //  - keep previous collapsed state
                    //  - whether or not to show the calculate link on the group totals
                    var groupByKeysForLevel = groupByKeys;
                    var parentGroupId = "";
                    var groupInfo;
                    var currentItemValues = [];
                    for (var level = 0; level < groupingData.length; level++) {
                        var groupData = groupingData[level];
                        var value_1 = valueGetters[level](collectionIndex, groupData.fieldName, groupData.dataSourceName, groupData.columnInfo);
                        currentItemValues[level] = value_1;
                        if (groupByKeysForLevel.has(value_1)) {
                            var mapValue = groupByKeysForLevel.get(value_1);
                            var groupTrackingId = mapValue.GroupId;
                            groupInfo = newGroups[groupTrackingId];
                            groupInfo.endIndex = collectionIndex;
                            groupByKeysForLevel = mapValue.SubGroupValues;
                            parentGroupId = mapValue.GroupId;
                        }
                        else { // New Entry
                            var groupTrackingId = _this.getGroupTrackingId(groupingData, currentItemValues);
                            groupInfo = new GroupInfo(groupTrackingId, value_1, collectionIndex, groupData.label, level, _this);
                            var addGroupToRowIndexArray = true;
                            if (parentGroupId) {
                                groupInfo.parentGroupTrackingId = parentGroupId;
                                var parentGroupInfo = newGroups[parentGroupId];
                                parentGroupInfo.addSubGroup(groupTrackingId);
                                if (parentGroupInfo.isCollapsed) {
                                    addGroupToRowIndexArray = false;
                                }
                            }
                            if (addGroupToRowIndexArray) {
                                groupInfo.rowIndex = newRowIndexToTrackingId.length + rowIndexOffset;
                                newRowIndexToTrackingId.push(groupTrackingId);
                            }
                            if (lastItemValues.length > 0) {
                                groupInfo.showGroupCalculateLink = $dyn.value(_this.context.DataBelow) === true ? true : false;
                                var previousGroupAtSameLevelTrackingId = _this.getGroupTrackingId(groupingData, lastItemValues.slice(0, level + 1));
                                var previousGroupAtSameLevelInfo = newGroups[previousGroupAtSameLevelTrackingId];
                                previousGroupAtSameLevelInfo.showGroupCalculateLink = false;
                                if (previousGroupAtSameLevelInfo.parentGroupTrackingId === groupInfo.parentGroupTrackingId) {
                                    groupInfo.previousGroupTrackingId = previousGroupAtSameLevelTrackingId;
                                    previousGroupAtSameLevelInfo.nextGroupTrackingId = groupTrackingId;
                                }
                            }
                            else {
                                groupInfo.showGroupCalculateLink = $dyn.value(_this.context.DataAbove) === true ? true : false;
                                if (!groupInfo.showGroupCalculateLink) {
                                    // Could be only creating the one group
                                    groupInfo.showGroupCalculateLink = $dyn.value(_this.context.DataBelow) === true ? true : false;
                                }
                            }
                            var oldGroup = _this.getGroup(groupTrackingId);
                            if (oldGroup && oldGroup.isCollapsed) {
                                groupInfo.isCollapsed = true;
                            }
                            newGroups[groupTrackingId] = groupInfo;
                            var mapValue = { GroupId: groupTrackingId };
                            groupByKeysForLevel.set(value_1, mapValue);
                            if (level < lastGroupingLevel) {
                                mapValue.SubGroupValues = new Map();
                                groupByKeysForLevel = mapValue.SubGroupValues;
                            }
                            parentGroupId = mapValue.GroupId;
                        }
                    }
                    lastItemValues = currentItemValues;
                    // Set parent group on data row
                    if ($dyn.serverForm && $dyn.serverForm.isModel(item)) {
                        item.setValue(reactGrid.PARENT_GROUP_KEY, groupInfo.trackingId, false);
                    }
                    else {
                        item[reactGrid.PARENT_GROUP_KEY] = groupInfo.trackingId;
                    }
                    var addItemToRowIndexArray = true;
                    var groupInfoInHierarchy = groupInfo;
                    while (groupInfoInHierarchy) {
                        if ($dyn.serverForm && $dyn.serverForm.isModel(item)) {
                            if (item.isMarked) {
                                groupInfoInHierarchy.adjustMarkedCount(1);
                            }
                        }
                        else {
                            if (item[reactGrid.ISMARKED_NAME]) {
                                groupInfoInHierarchy.adjustMarkedCount(1);
                            }
                        }
                        columnsWithTotals.forEach(function (columnToTotal) {
                            var modelValue = _this.context.getCollectionData(collectionIndex, columnToTotal.FieldName, columnToTotal.DataSourceName);
                            if (modelValue !== undefined) {
                                groupInfoInHierarchy.addFieldTotal(modelValue, columnToTotal.FieldName, columnToTotal.DataSourceName);
                            }
                        });
                        // Only add row to visible rows if all ancestor groups are expanded
                        if (addItemToRowIndexArray && groupInfoInHierarchy.isCollapsed) {
                            addItemToRowIndexArray = false;
                        }
                        if (groupInfoInHierarchy.parentGroupTrackingId) {
                            groupInfoInHierarchy = newGroups[groupInfoInHierarchy.parentGroupTrackingId];
                        }
                        else {
                            // set to undefined to break the while loop
                            groupInfoInHierarchy = undefined;
                        }
                    }
                    if (addItemToRowIndexArray) {
                        item.rowIndex = newRowIndexToTrackingId.length + rowIndexOffset;
                        var rowTrackingId = _this.context.getTrackingIdFromCollectionIndex(collectionIndex);
                        newRowIndexToTrackingId.push(rowTrackingId);
                    }
                });
                return { groups: newGroups, trackingIds: newRowIndexToTrackingId };
            };
            GroupingManager.prototype.getGroup = function (trackingId) {
                if (this.rootId && this.collectionName) {
                    return GroupingManager.getGroup(this.rootId, this.collectionName, trackingId);
                }
                else if (this.fallbackGroupInfoCache) {
                    return this.fallbackGroupInfoCache[trackingId];
                }
            };
            return GroupingManager;
        }());
        reactGrid.GroupingManager = GroupingManager;
        /* tslint:disable:max-classes-per-file */
        var GroupInfo = /** @class */ (function () {
            function GroupInfo(trackingId, key, startIndex, label, level, groupingManager) {
                this.trackingId = trackingId;
                this.key = key;
                this.startIndex = startIndex;
                this.label = label;
                this.level = level;
                this.groupingManager = groupingManager;
                this.columnTotals = {};
                this.isCollapsed = false;
                this.endIndex = startIndex;
                this.markedCount = 0;
                this.showGroupCalculateLink = true;
                this.rowIndex = -1;
                this.parentGroupTrackingId = "";
                this.nextGroupTrackingId = "";
                this.previousGroupTrackingId = "";
                this.isActiveDataRow = false;
            }
            Object.defineProperty(GroupInfo.prototype, "numberOfRows", {
                get: function () {
                    return this.endIndex - this.startIndex + 1;
                },
                enumerable: false,
                configurable: true
            });
            GroupInfo.prototype.addSubGroup = function (subGroupTrackingId) {
                if (!this.subGroups) {
                    this.subGroups = [];
                }
                this.subGroups.push(subGroupTrackingId);
            };
            GroupInfo.prototype.hasSubGroups = function () {
                return this.subGroups && this.subGroups.length > 0;
            };
            GroupInfo.prototype.getFirstSubGroupTrackingId = function () {
                var retVal = "";
                if (this.subGroups) {
                    // OR with empty string incase that spot is undefined
                    retVal = this.subGroups[0] || "";
                }
                return retVal;
            };
            GroupInfo.prototype.getLastSubGroupTrackingId = function () {
                var retVal = "";
                if (this.subGroups) {
                    // OR with empty string incase that spot is undefined
                    retVal = this.subGroups[this.subGroups.length - 1] || "";
                }
                return retVal;
            };
            GroupInfo.prototype.getSubGroups = function () {
                return this.subGroups;
            };
            GroupInfo.prototype.getValue = function (propertyName, dataSourceName) {
                if (propertyName === GROUP_BY_KEY) {
                    return this.key + " (" + this.numberOfRows + ")" + ($dyn.peek(this.groupingManager.context.ShowGroupHeaderLabel) ? " [" + this.label + "]" : "");
                }
                else if (propertyName === SHOW_GROUP_CALCULATE_LINK) {
                    return this.showGroupCalculateLink;
                }
                else if (propertyName === reactGrid.MASTERTRACKINGID) {
                    return this.trackingId;
                }
                else if (propertyName === reactGrid.ISSELECTED_NAME) {
                    return this.trackingId === $dyn.value(this.groupingManager.context.InternalSelectedRowTrackingId);
                }
                else if (propertyName === reactGrid.ISACTIVE_NAME) {
                    return this.isActiveDataRow;
                }
                else if (propertyName === IS_COLLAPSED_KEY) {
                    return this.isCollapsed;
                }
                else if (propertyName === GROUP_LEVEL_KEY) {
                    return this.level;
                }
                else if (propertyName === reactGrid.ISMARKED_NAME) {
                    if (this.markedCount === this.numberOfRows) {
                        return 1 /* checked */;
                    }
                    else if (this.markedCount > 0) {
                        return 2 /* indeterminate */;
                    }
                    else {
                        return 0 /* unchecked */;
                    }
                }
                else if (propertyName === reactGrid.ISACTIONABLE_NAME) {
                    return false;
                }
                var totalKey = dataSourceName ? dataSourceName + "_" + propertyName : propertyName;
                if (this.columnTotals[totalKey]) {
                    return this.columnTotals[totalKey].GetNumberString();
                }
            };
            GroupInfo.prototype.addFieldTotal = function (value, fieldName, dataSourceName) {
                var totalKey = dataSourceName ? dataSourceName + "_" + fieldName : fieldName;
                if (!this.columnTotals[totalKey]) {
                    this.columnTotals[totalKey] = new ControlLibrary.BigNumber({
                        initialValue: 0,
                    });
                }
                this.columnTotals[totalKey].add(value);
            };
            /**
             * Adjust the marked count for the group
             * @param adjustment Value to add to marked count
             */
            GroupInfo.prototype.adjustMarkedCount = function (adjustment) {
                this.markedCount += adjustment;
            };
            return GroupInfo;
        }());
        reactGrid.GroupInfo = GroupInfo;
    })(reactGrid = $dyn.reactGrid || ($dyn.reactGrid = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=GroupingManager.js.map
